/* Easify (product options app) shows its fields in Italian only: its multi-language feature is a paid plan.
   On non-Italian storefronts this translates what the customer sees — labels, help texts, placeholders,
   list items, messages and the cart line properties — while the values sent with the order stay Italian,
   so the workshop keeps reading orders exactly as before. Add new fields to DICT when Easify changes. */
(function () {
  var lang = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  if (lang === 'it') return;

  var EN = {
    'Circonferenza capo': 'Head circumference',
    'Misura la circonferenza della tua testa in base a dove vorrai posizionare la corona': 'Measure around your head where you want the wreath to sit',
    'Seleziona una dimensione': 'Select a size',
    'Colore accessori principale': 'Main accessory color',
    'Colore accessori principali': 'Main accessory color',
    'Seleziona un colore o scegli nessun accessorio': 'Select a color or choose no accessory',
    'Nessun accessorio': 'No accessory',
    'Colore accessori secondario': 'Second accessory color',
    'Colore accessori secondari': 'Second accessory color',
    'Per la nebbiolina o alle bacche se associate con i fiori': "For the baby's breath or the berries when paired with flowers",
    'Colore nastro': 'Ribbon color',
    'Colore secondo nastro': 'Second ribbon color',
    'Colore nastro 2': 'Second ribbon color',
    'Se hai scelto il nastro doppio seleziona il colore che andrà dietro': 'If you chose the double ribbon, pick the color that goes behind',
    'Seleziona un colore per il secondo nastro': 'Select a color for the second ribbon',
    'Colore scritta nastro': 'Ribbon lettering color',
    'Colore scritta': 'Lettering color',
    'Stile scritta del fiocco': 'Bow lettering style',
    'Stile scritta': 'Lettering style',
    'Scegli lo stile della scritta': 'Choose the lettering style',
    'Corsivo': 'Script',
    'Stampatello': 'Block letters',
    'Se hai scelto la personalizzazione che sia ricamato o in vinile': 'If you chose lettering, embroidered or vinyl',
    'Seleziona un colore per la scritta': 'Select a color for the lettering',
    'Seleziona un colore': 'Select a color',
    'Personalizza il nastro sinistro': 'Personalize the left ribbon',
    'Personalizza il nastro destro': 'Personalize the right ribbon',
    'Personalizzazione fiocco 1': 'Bow lettering 1',
    'Personalizzazione fiocco 2': 'Bow lettering 2',
    'Se questo campo verrà compilato senza aver scelto una delle due varianti di personalizzazione del fiocco (stampa in vinile o ricamo), la frase verrà ignorata.': 'If you fill in this field without choosing one of the two bow lettering options (vinyl print or embroidery), the text will be ignored.',
    'Dott.ssa Maria Rossi': 'Dr. Maria Rossi',
    'Giurisprudenza · 28.03.2027': 'Law · 03/28/2027',
    'Personalizzazioni interne alle foglie': 'Engraving on the leaves',
    'Personalizzazioni': 'Engraving',
    'Inserisci se vuoi nome, data, facoltà, luogo': 'Add a name, date, faculty or place if you like',
    'Maria Rossi, 28.03.2027, Giurisprudenza, Roma': 'Maria Rossi, 03/28/2027, Law, Rome',
    'Frase personalizzata': 'Custom phrase',
    'Frase': 'Phrase',
    "Verrà inserita all'interno delle foglie come le altre personalizzazioni.": 'It will be engraved on the leaves along with the other personalization.',
    'Dura lex, sed lex, con un avvocato come te siamo più tranquilli!': 'Dura lex, sed lex – with a lawyer like you we all feel safer!',
    'Inserisci un nome, le tue/vostre iniziali o una piccola frase': 'Enter a name, your initials or a short phrase',
    'Personalizzazione': 'Personalization',
    'Nome': 'Name',
    'Facoltà/Corso di Laurea': 'Faculty/Degree program',
    'Facoltà': 'Faculty',
    'Data': 'Date',
    'Luogo': 'Place',
    'Foglie alloro': 'Laurel leaves',
    'Personalizza la prima foglia': 'Personalize the first leaf',
    'Personalizza la seconda foglia': 'Personalize the second leaf',
    'Personalizza la terza foglia': 'Personalize the third leaf',
    'Personalizza la quarta foglia': 'Personalize the fourth leaf',
    'Personalizza la quinta foglia': 'Personalize the fifth leaf',
    'Personalizza la sesta foglia': 'Personalize the sixth leaf',
    'Personalizza la settima foglia': 'Personalize the seventh leaf',
    'Personalizza la ottava foglia': 'Personalize the eighth leaf',
    'Personalizza la nona foglia': 'Personalize the ninth leaf',
    'Personalizza la decima foglia': 'Personalize the tenth leaf',
    'Opzione 1': 'Option 1',
    'Rosso': 'Red', 'Blu': 'Blue', 'Verde': 'Green', 'Nero': 'Black', 'Bianco': 'White', 'Oro': 'Gold', 'Argento': 'Silver',
    'Rosa': 'Pink', 'Magenta': 'Magenta', 'Giallo': 'Yellow', 'Glicine': 'Wisteria', 'Champagne': 'Champagne',
    'Bordeaux': 'Burgundy', 'Carta da zucchero': 'Powder blue', 'Vinaccia': 'Wine red',
    'Campo obbligatorio': 'Required field',
    'Campi obbligatori': 'Required fields'
  };
  var PATTERNS = [
    [/^Scrivi almeno (.+) caratteri$/, 'Type at least $1 characters'],
    [/^Puoi scrivere al massimo (.+) caratteri$/, 'You can type up to $1 characters'],
    [/^Inserisci un valore di almeno (.+)$/, 'Enter a value of at least $1'],
    [/^Inserisci un valore non superiore a (.+)$/, 'Enter a value no greater than $1'],
    [/^Scegli almeno (.+) opzioni$/, 'Choose at least $1 options'],
    [/^Puoi scegliere al massimo (.+) opzioni$/, 'Choose up to $1 options']
  ];

  function tr(text) {
    if (!text) return null;
    var raw = text.trim();
    var star = '';
    if (/\s\*$/.test(raw)) { star = ' *'; raw = raw.replace(/\s\*$/, ''); }
    if (EN[raw]) return EN[raw] + star;
    for (var i = 0; i < PATTERNS.length; i++) if (PATTERNS[i][0].test(raw)) return raw.replace(PATTERNS[i][0], PATTERNS[i][1]) + star;
    return null;
  }
  window.luEasifyTr = tr;

  function translateTree(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node, list = [];
    while ((node = walker.nextNode())) list.push(node);
    list.forEach(function (n) {
      var t = tr(n.nodeValue);
      if (t) n.nodeValue = n.nodeValue.replace(n.nodeValue.trim(), t);
    });
    root.querySelectorAll('[placeholder]').forEach(function (el) {
      var t = tr(el.getAttribute('placeholder'));
      if (t) el.setAttribute('placeholder', t);
    });
  }

  /* A chosen list item keeps its Italian value (that is what the order receives):
     show the translation on top of the field instead of changing the value. */
  function overlay(input) {
    if (!input.parentNode) return;
    var shown = input.parentNode.querySelector('.lu-tpo-shown');
    var t = tr(input.value);
    if (!t) {
      if (shown) shown.remove();
      input.classList.remove('lu-tpo-masked');
      return;
    }
    if (!shown) {
      shown = document.createElement('span');
      shown.className = 'lu-tpo-shown';
      shown.setAttribute('aria-hidden', 'true');
      input.parentNode.appendChild(shown);
    }
    shown.textContent = t;
    input.classList.add('lu-tpo-masked');
  }

  var style = document.createElement('style');
  style.textContent = '.tpo_option-input-inner{position:relative}.lu-tpo-masked{color:transparent!important}' +
    '.lu-tpo-shown{position:absolute;left:12px;right:36px;top:50%;transform:translateY(-50%);pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font:inherit}';
  document.head.appendChild(style);

  /* Each step is guarded: Easify re-renders while we work, and one failing node must never stop
     the translation for the rest of the visit. */
  function each(selector, fn) {
    document.querySelectorAll(selector).forEach(function (el) {
      try { fn(el); } catch (e) {}
    });
  }
  var busy = false;
  function run() {
    if (busy) return;
    busy = true;
    try {
      runSteps();
    } finally {
      busy = false;
    }
  }
  function runSteps() {
    each('.tpo_option-set-wrapper', translateTree);
    each('.tpo_option-set-wrapper input.tpo_option-dropdown', overlay);
    /* cart page: property names and values */
    each('.lu-cart__prop', function (p) {
      if (p.dataset.luTr) return;
      p.dataset.luTr = '1';
      var label = p.querySelector('.muted');
      if (label) {
        var name = label.textContent.replace(/:\s*$/, '');
        var tn = tr(name);
        if (tn) label.textContent = tn + ':';
      }
      var valueNode = label ? label.nextSibling : null;
      if (valueNode && valueNode.nodeType === 3) {
        var tv = tr(valueNode.nodeValue);
        if (tv) valueNode.nodeValue = ' ' + tv;
      }
    });
  }

  function boot() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(function () { window.requestAnimationFrame(run); }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    /* Easify fills the chosen value from script, which does not show up as a DOM change */
    setInterval(function () {
      each('.tpo_option-set-wrapper input.tpo_option-dropdown', overlay);
    }, 400);
    /* Late renders that slip past the observer (Easify fills some labels from script) */
    var passes = 0;
    var late = setInterval(function () {
      run();
      if (++passes >= 20) clearInterval(late);
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
